import { Component, OnInit } from '@angular/core';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';

@Component({
  selector: 'itpx-image-pre-embed-modal',
  templateUrl: './image-pre-embed-modal.component.html',
  styleUrls: ['./image-pre-embed-modal.component.css']
})
export class ImagePreEmbedModalComponent implements OnInit {

  private form: FormGroup;

  constructor(
    private modalService: SmartModalService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
        alt: null
    });
  }

  private onSubmit() {
    this.modalService.sendResult(this.form.value);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/controls/html-editor/image-pre-embed-modal/image-pre-embed-modal.component.ts